module.exports = __webpack_public_path__ + "h5/img/test-icon-3.2c06087f.png";